import numeral from 'numeral'

import { SeasonalStat } from '../helper'

export interface SeasonalStatsProps {
  seasonalStats: SeasonalStat[] | undefined
  valueHeader: string
}

export const SeasonalStats = ({
  seasonalStats,
  valueHeader
}: SeasonalStatsProps) => {
  if (!seasonalStats) {
    return null
  }
  return (
    <table className='w-full mt-5 pb-2 border-y-2'>
      <thead>
        <tr>
          <th className='text-right pr-8 py-4 font-normal'>Year</th>
          <th className='text-left pl-8 border-l py-4 font-normal'>
            {valueHeader}
          </th>
        </tr>
      </thead>
      <tbody>
        {seasonalStats.map(seasonalStat => {
          const isCurrentSeason =
            new Date().getFullYear().toString() === seasonalStat.season

          const dotClasses = isCurrentSeason
            ? 'bg-forestDeep w-4 h-4'
            : 'bg-limeBright w-3 h-3'
          return (
            <tr key={seasonalStat.season}>
              <td className='text-right pr-8 py-4 font-display-rebrand text-xl'>
                {seasonalStat.season}
              </td>
              <td className='relative text-left pl-8 border-l py-4 font-display-rebrand text-3xl'>
                <div
                  className={`absolute  left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full ${dotClasses}`}
                />
                {numeral(seasonalStat.value).format('0,0')}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
